<template>
  <div>
    <router-link to="/roast/roast">
      <img alt="" class="bg" src="../../assets/photo/web_1.png">
    </router-link>
  </div>
</template>
<script>
export default {
  name: "company",
  components: {},
  mounted() {
    document.title = "一个树洞";
  }
}
</script>

<style>
.bg {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  width: 100%;
  height: 100%;
}

.logo {
  position: absolute;
  top: 20px;
  left: 20px;
  z-index: 2;
}

.wz {
  position: absolute;
  top: 20px;
  left: 20px;
  z-index: 2;
}
</style>
